import React, { Component, PropTypes } from 'react';
import "../CSS/checkbox.css"

class Checkbox extends Component {
  state = {
    isChecked: false,
  }
  componentWillReceiveProps(nextProps){
    //this.toggleCheckboxChange()
  }
  toggleCheckboxChange = () => {
    const { handleCheckboxChange, label } = this.props;

    this.setState(({ isChecked }) => (
      {
        isChecked: !isChecked,
      }
    ));

    handleCheckboxChange(label);
  }

  render() {
    const { label } = "Add"
    const { isChecked } = this.state;

    return (
      <label className="container">
      <input
                        type="checkbox"
                        id="upgradesCheck"
                        value={label}
                        checked={isChecked}
                        onChange={this.toggleCheckboxChange}
                    />
        <span className="checkmark"></span>
        </label>
    );
  }
}
export default Checkbox



// WEBPACK FOOTER //
// ./src/Components/Checkbox.js